import { Client } from "@microsoft/microsoft-graph-client";
import { AuthCodeMSALBrowserAuthenticationProvider } from "@microsoft/microsoft-graph-client/authProviders/authCodeMsalBrowser";
import { InteractionType, PublicClientApplication } from "@azure/msal-browser";
import { loginScopes } from "./authConfig";

export function getGraphClient(instance: PublicClientApplication) {
  const authProvider = new AuthCodeMSALBrowserAuthenticationProvider(
    instance,
    {
      account: instance.getAllAccounts()[0],
      scopes: loginScopes,
      interactionType: InteractionType.Redirect,
    }
  );

  return Client.initWithMiddleware({ authProvider });
}